import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, LogOut } from "lucide-react";
import { ADMIN } from "@/constants/testIds";
import { SECTIONS } from "@/lib/sections";
import { useAuth } from "@/context/AuthContext";

export function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <aside className="fixed inset-y-0 left-0 w-[260px] flex flex-col border-r border-gray-200 bg-white">
        <div className="flex items-center gap-2 px-6 py-5 border-b border-gray-200">
          <div className="flex h-8 w-8 items-center justify-center rounded-md bg-black text-[#D4AF37] font-chivo font-bold text-sm">K</div>
          <div>
            <p className="font-chivo font-bold text-sm text-gray-900 leading-none">KIRA Score</p>
            <p className="text-[11px] text-gray-500 leading-none mt-0.5">Publishing Desk</p>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          <NavLink
            to="/admin"
            end
            data-testid={ADMIN.sidebarDashboard}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive ? "bg-gray-900 text-white" : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`
            }
          >
            <LayoutDashboard className="h-4 w-4" /> Dashboard
          </NavLink>
          <p className="px-3 pt-4 pb-1 text-[10px] font-mono uppercase tracking-[0.15em] text-gray-400">Research Sections</p>
          {SECTIONS.map((s) => (
            <NavLink
              key={s.key}
              to={`/admin/section/${s.key}`}
              data-testid={`${ADMIN.sidebarSection}-${s.key}`}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive ? "bg-gray-900 text-white" : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                }`
              }
            >
              <s.icon className="h-4 w-4" />
              {s.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-gray-200 p-3">
          <div className="flex items-center justify-between px-3 py-2">
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{user?.name}</p>
              <p className="text-[11px] text-gray-500 capitalize">{user?.role}</p>
            </div>
            <button
              data-testid={ADMIN.sidebarLogout}
              onClick={handleLogout}
              className="flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-900"
              title="Logout"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
      </aside>
      <main className="flex-1 ml-[260px] p-6">{children}</main>
    </div>
  );
}
